import ThemePreviewSnackbar from './ThemePreviewSnackbar';

export default ThemePreviewSnackbar;
